import { gql } from '@apollo/client';

export const GUARDS_LIST = gql`
  query GuardsList {
    employeesList {
      items {
        id
        firstName
        lastName
      }
    }
  }
`; 